import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Facility extends EntityDto implements IEntityDto {
    Facility_Id: string;
    FacilityName: string;
    Description: string;
    Unit: number;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Facility_Id = "00000000-0000-0000-0000-000000000000";
        this.FacilityName = "";
        this.Description = "";
        this.TotalCount = 0;
        this.Unit = 0;
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'FacilityName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Facility Name is required' },
            // { FieldName: 'Unit', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Unit is required' },

        ];
    }
}
